import { COMPONENTS, EVENTS } from '../../lib/constants';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import HELPERS from '../../lib/globals/helpers/Helpers';
import { FastplayDialogueView } from '../../view/fastplay-dialogue/FastplayDialogue';
import { sendManualBet, sendfreeSpinStep } from './helpers/SendBet';
import { handleModal } from './helpers/SpinButtonHelpers';
const clickTimestamps = [];
const clickThreshold = 1500;
const clickCountThreshold = 10;
const events = [
	EVENTS.REEL_FINISHED,
	EVENTS.AUTO_STARTED,
	EVENTS.BET_PLACED,
	EVENTS.SETTINGS_UPDATE,
	EVENTS.MODAL,
	EVENTS.NOTIFICATION,
	EVENTS.IS_DISABLED,
	EVENTS.QUEST_CLAIM
];

class SpinButtonController {
	constructor(vc, conf) {
		this.vc = vc.holder;
		this.button = this.vc.spin_stop.ui_btn_spin;
		this.button.handler = this.handler.bind(this);
		this.reels = GameConfigs.reelComponent;
		this.disable = GameConfigs.disabled.spin;
		this.localBetSent = false;
		this.unclickable = false;
		this.isSpaceKeyDown = false;

		if (GameConfigs.config.hasbonus) {
			return;
		} else {
			this.addKeyDownEvent();
			this.addEventListeners();
			setTimeout(() => {
				if (GameConfigs.autospin.isAutoOn) {
					if (this.button.spin) {
						this.button.showStop();
					}
					this.handlePauseAuto(false);
				}
			}, 0);
		}
	}

	handleEvent(event) {
		switch (event.type) {
			case 'keydown':
				if (event.keyCode === 32) {
					if (!this.isSpaceKeyDown) {
						this.isSpaceKeyDown = true;
						// if (this.unclickable) return;
						if (this.disable) {
							this.button.animateDisable();
						} else {
							this.button.mouseDown();
							this.handler();
						}
					}
				}
				break;
			case 'keyup':
				if (event.keyCode === 32) {
					if (this.isSpaceKeyDown) {
						this.isSpaceKeyDown = false;
						!this.disable && this.button.mouseUp();
					}
				}
				break;
			case EVENTS.REEL_FINISHED:
				if (GameConfigs.bonusBuy && GameConfigs.notification.code === 0) {
					this.removeEventListeners();
					this.removeKeyDownEvent();
					this.button.handler = null;
					if (GameConfigs.uiComponent[COMPONENTS.QUEST_STATUS_BAR]) {
						GameConfigs.uiComponent.removeView(
							GameConfigs.uiComponent[COMPONENTS.QUEST_STATUS_BAR]
						);
					}
					if (GameConfigs.autospin.isAutoOn && !GameConfigs.autospin.pause) {
						this.handlePauseAuto(true);
					}
					return;
				}
				this.localBetSent = false;
				this.button.mouseUp();
				if (!this.button.spin && !GameConfigs.autospin.isAutoOn) {
					this.button.pressStopButton();
				}
				if (this.isSpaceKeyDown && !GameConfigs.autospin.isAutoOn) {
					setTimeout(() => {
						this.handler();
					}, 0);
				}
				break;
			case EVENTS.AUTO_STARTED:
				GameConfigs.autospin = event.detail;
				if (event.detail.isAutoOn) {
					this.handler();
				} else {
					if (!this.button.spin) {
						this.button.pressStopButton();
					}
				}
				break;
			case EVENTS.BET_PLACED:
				GameConfigs.betPlaced = event.detail.placed;
				if (event.detail.placed) return;
				if (GameConfigs.autospin.isAutoOn) {
					this.autoNextStep();
				}
				break;
			case EVENTS.MODAL:
				if (this.checkMobile(event.detail.modal)) {
					this.button.interactive = false;
				} else {
					this.button.interactive = true;
					if (
						event.detail.modal !== 'fastplay_dialogue' &&
						event.detail.modal !== 'quest_prompt' &&
						event.detail.modal !== 'bonus_game_finish' &&
						event.detail.modal !== 'win' &&
						this.disable &&
						!this.error
					) {
						this.disable = false;
						this.button.toggleButton(true);
					}
					if (event.detail.modal === 'freespin_win') {
						if (GameConfigs.autospin.isAutoOn) {
							this.handleStopAuto();
							if (!this.button.spin) {
								this.button.pressStopButton();
							}
						}
					}
				}
				break;
			case EVENTS.NOTIFICATION:
				if (event.detail.notification) {
					if (!this.button.spin) {
						this.button.pressStopButton();
					}
					if (this.reels.rotating) {
						this.reels.emergencyStop();
					}
				}
				break;
			case EVENTS.IS_DISABLED:
				this.unclickable = event.detail.disable.spin;

				break;
			case EVENTS.SETTINGS_UPDATE:
				if (event.detail.data.keyboard_shortcuts === undefined) return;
				if (event.detail.data.keyboard_shortcuts) {
					if (this.removed_event) {
						window.addEventListener('keydown', this, false);
						window.addEventListener('keyup', this, false);
					}
				} else {
					window.removeEventListener('keydown', this, false);
					window.removeEventListener('keyup', this, false);
				}
				break;
			default:
				break;
		}
	}

	checkMobile(modal) {
		return (
			(modal === 'settings' || modal === 'quest' || modal === 'quest_claim') &&
			(window.isMobile || window.isTablet)
		);
	}

	handleFastClick() {
		const now = Date.now();
		clickTimestamps.push(now);
		const filteredTimestamps = clickTimestamps.filter(
			(timestamp) => now - timestamp <= clickThreshold
		);
		clearTimeout(this.fastClickTimeout);
		this.fastClickTimeout = setTimeout(() => {
			if (filteredTimestamps.length >= clickCountThreshold) {
				this.disable = true;
				this.showFastPlayDialogue();
			}
		}, 0);
	}

	showFastPlayDialogue() {
		handleModal('fastplay_dialogue');
		GameConfigs.uiComponent.addView(FastplayDialogueView);
		this.button.pressStopButton();
		GameConfigs.uiComponent[
			COMPONENTS.FAST_PLAY_DIALOGUE
		].CloseController.onClose(() => {
			GameConfigs.fastPlayDialogue = true;
			this.disable = false;
			this.button.toggleButton(true);
			if (GameConfigs.autospin.isAutoOn) {
				this.button.pressSpinButton();
				this.autoNextStep();
			}
		});
	}

	handler() {
		if (GameConfigs.modal === 'prompt') {
			handleModal('');
		}
		if (GameConfigs.quest_is_active && GameConfigs.quest_claim.leftBets === 0)
			return;
		if (this.unclickable) return;
		if (
			this.disable ||
			(GameConfigs.isFreeSpin && GameConfigs.freeSpinLocal.show)
		) {
			this.button.toggleButton(false);
			this.button.animateDisable();
			return;
		}
		this.button.toggleButton(true);
		this.checkFastPlay();
		if (this.reels.rotating) {
			this.reels.fastStop();
			if (!GameConfigs.autospin.isAutoOn) {
				this.button.pressStopButton();
			}
		} else {
			if (!GameConfigs.bonusBuy) {
				if (!this.localBetSent) {
					if (this.button.spin) {
						this.button.pressSpinButton();
					}
					if (GameConfigs.autospin.isAutoOn) {
						if (this.checkAuto()) {
							this.sendBet();
						}
					} else {
						this.sendBet();
					}
				}
			}
		}
	}

	handlePauseAuto(pause) {
		HELPERS.dispatchCustomEvent(EVENTS.AUTO_STARTED, {
			numOfBets: GameConfigs.autospin.numOfBets,
			isAutoOn: !pause,
			leftBets: GameConfigs.autospin.leftBets,
			pause: pause
		});
	}

	handleStopAuto() {
		HELPERS.dispatchCustomEvent(EVENTS.AUTO_STARTED, {
			numOfBets: GameConfigs.autospin.numOfBets,
			isAutoOn: false,
			leftBets: 0,
			pause: false
		});
	}

	autoNextStep() {
		if (this.localBetSent) {
			return;
		} else {
			if (GameConfigs.autospin.isAutoOn) {
				if (this.checkAuto()) {
					clearTimeout(this.autoTimeout);
					this.autoTimeout = setTimeout(() => {
						this.handler();
					}, 200);
				}
			}
		}
	}

	checkFastPlay() {
		if (
			!GameConfigs.fastPlayDialogue &&
			!GameConfigs.settings.fast_spin &&
			!GameConfigs.autospin.isAutoOn &&
			!GameConfigs.bonusBuy
		) {
			this.handleFastClick();
		}
	}
	checkAuto() {
		if (
			Number(GameConfigs.autospin.leftBets) >=
				Number(GameConfigs.autospin.numOfBets) &&
			GameConfigs.autospin.numOfBets !== ''
		) {
			this.handleStopAuto();
			return false;
		}
		return true;
	}

	sendBet() {
		if (GameConfigs.autospin.isAutoOn) {
			GameConfigs.autospin.numOfBets !== '' && GameConfigs.autospin.leftBets++;
		}
		if (GameConfigs.freeSpinLocal.started) {
			sendfreeSpinStep();
		} else {
			sendManualBet();
		}
	}

	//ADD/REMOVE events
	addEventListeners() {
		for (let i = 0; i < events.length; i++) {
			window.addEventListener(events[i], this, false);
		}
	}
	removeEventListeners() {
		for (let i = 0; i < events.length; i++) {
			window.removeEventListener(events[i], this, false);
		}
	}

	addKeyDownEvent() {
		if (
			GameConfigs.settings.keyboard_shortcuts &&
			!window.isMobile &&
			!window.isTablet
		) {
			this.removed_event = false;
			window.addEventListener('keydown', this, false);
			window.addEventListener('keyup', this, false);
		} else {
			this.removed_event = true;
		}
	}

	removeKeyDownEvent() {
		if (
			GameConfigs.settings.keyboard_shortcuts &&
			!window.isMobile &&
			!window.isTablet
		) {
			this.removed_event = true;
			window.removeEventListener('keydown', this, false);
			window.removeEventListener('keyup', this, false);
		}
	}
}

export default SpinButtonController;
